/** Ön rezervasyon formu doğrulaması (iki formda da kullanılır). */
export const validateReservationForm = (form) => {
  const errors = {};
  if (!form.firstName || form.firstName.trim().length < 2) errors.firstName = 'Lütfen adınızı yazın.';
  if (!form.lastName || form.lastName.trim().length < 2) errors.lastName = 'Lütfen soyadınızı yazın.';
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test((form.email || '').trim()))
    errors.email = 'Geçerli bir e-posta adresi yazın.';
  const digits = (form.phone || '').replace(/\D/g, '');
  if (digits.length < 10) errors.phone = 'Telefon numaranızı 10 hane olacak şekilde yazın.';
  return errors;
};

export const focusFirstError = (errors, order = ['firstName', 'lastName', 'email', 'phone']) => {
  const first = order.find((k) => errors[k]);
  if (!first) return;
  const el = document.querySelector(`[data-field="${first}"]`);
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(() => el.focus({ preventScroll: true }), 350);
  }
};
